
import axios from 'axios';
import { serverIp, allTicketTypeList, polutionTypes, } from '@/configs/index';
import {
  defineComponent,
  reactive,
  ref,
  toRaw,
  UnwrapRef,
  computed,
  watch,
} from 'vue';

import {
  DatePicker,
  ConfigProvider,
  message,
  Input,
  Upload,
  Table,
  Button,
  Select,
  TreeSelect,
  Row,
  Col,
  Form,
  Modal,
} from 'ant-design-vue';
import moment, { Moment, } from 'moment';

import { useStore, } from 'vuex';
import { ValidateErrorEntity, } from 'ant-design-vue/es/form/interface';
import zhCN from 'ant-design-vue/es/locale/zh_CN';

import { initHandleTimeLimitFn, } from '@/utils/tools';

const { Item, } = Form;
const { Option, } = Select;
const { TextArea, } = Input;

export default defineComponent({
  components: {
    Form,
    Upload,
    Modal,
    Item,
    Row,
    Col,
    Input,
    TextArea,
    Select,
    TreeSelect,
    Option,
    ConfigProvider,
    DatePicker,
  },
  props: {
    isList: {
      type: Boolean,
      default: () => false,
    },
    ticketModalVisible: {
      type: Boolean,
      default: () => false,
    },
    selectOrderCode: {
      type: String,
      default: () => '',
    },
    action: {
      type: String,
      default: () => '',
    },
    hotGridId: {
      type: String,
      default: () => '',
    },
    curGrid: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['update:isList',
    'update:ticketModalVisible',
    'updateTicketDetail',],
  setup (props, context) {
    const store = useStore();
    const { grantTicktTypeList, } = store.state.userCenter;
    // 弹窗标题
    const titles = ref<string>('创建工单');
    const treeData = [
      {
        title: 'Node1',
        value: '0-0',
        key: '0-0',
        children: [
          {
            title: 'Child Node1',
            value: '0-0-2',
            key: '0-0-2',
          },
          {
            title: 'Child Node2',
            value: '0-0-2',
            key: '0-0-2',
          },
        ],
      },
      {
        title: 'Node2',
        value: '0-1',
        key: '0-1',
      },
    ];

    const acceptTime = reactive<any>({
      hour: null,
      minute: null,
    });
    const handleTime = reactive<any>({
      hour: null,
      minute: null,
    });

    /*
     * const typeList = [
     *   '餐饮油烟',
     *   '微型空气站',
     *   '标准站',
     *   '工业企业源',
     *   '工地扬尘',
     *   '道路扬尘',
     *   '交通污染',
     *   '激光雷达',
     *   '热点网格_PM₂.₅',
     *   '热点网格_PM₁₀',
     *   '其他',
     * ];
     * 上传组件
     */
    const fileList = ref<any>([]);
    const previewImage = ref<any>(null);
    const previewVisible = ref<boolean>(false);

    const getBase64 = (file: any) => new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

    const handlePreview = async (file: any) => {
      let preview: any = null;

      if (!file.url && !file.preview) {
        // eslint-disable-next-line require-atomic-updates
        preview = await getBase64(file.originFileObj);
      }
      previewImage.value = file.url || preview;
      previewVisible.value = true;
    };

    const handleChange = (file: any) => {
      fileList.value = file.fileList;
    };

    /**
     * @method getDetail 获取工单详情
     * @param {*} val 工单ID
     * @return {*}
     */
    const getDetail = (val: string) => {
      store.dispatch('ticket/getRepairOrderInfoById', {
        repairOrderId: val,
      });
    };

    const userListById = computed(() => store.state.ticket.userListById);

    const companyList = computed(() => store.state.ticket.companyList);

    // 抄送人选项
    const duplicateOptions = ref<any>([]);
    // 表单
    const formRef = ref();
    const formState = reactive<any>({
      title: '',
      address: props.curGrid.address,
      type: 1,
      describetion: '',
      unit: '',
      person: '',
      duplicateId: [],
      handleTimeLimit: '',
    });
    const rules = {
      title: [
        {
          required: true,
          message: '请输入标题',
          trigger: 'blur',
        },
      ],
      type: [
        {
          required: true,
          message: '',
        },
      ],
      unit: [
        {
          required: true,
          message: '',
          trigger: 'change',
        },
      ],
      person: [
        {
          required: true,
          message: '',
          trigger: 'change',
        },
      ],
      address: [
        {
          required: true,
          message: '请输入详细地址',
          trigger: 'blur',
        },
      ],
      describetion: [
        {
          required: true,
          message: '请输入工单描述',
          trigger: 'blur',
        },
        {
          min: 2,
          max: 200,
          message: '长度需控制在2-200',
          trigger: 'blur',
        },
      ],
    };

    const disabledDate = (cur: string | any) => cur.valueOf() < moment().subtract(1, 'day').valueOf();
    const initHandleTimeLimit = () => {
      formState.handleTimeLimit = initHandleTimeLimitFn();
    };

    /**
     * @method handleCloseModal 关闭弹窗
     * @return {*}
     */
    const handleCloseModal = () => {
      formRef.value.resetFields();
      fileList.value = [];
      formState.unit = companyList.value?.[0]?.id;
      context.emit('update:ticketModalVisible', !props.ticketModalVisible);
    };

    const resetForm = () => {
      formRef.value.resetFields();
      fileList.value = [];
      formState.unit = companyList.value?.[0]?.id;
      acceptTime.hour = null;
      acceptTime.minute = null;
      handleTime.hour = null;
      handleTime.minute = null;
      handleCloseModal();
      initHandleTimeLimit();
    };

    const userInfo = computed(() => store.state.login.userInfo);

    const isNumber = (num: string) => {
      if (num && !Number.isNaN(parseFloat(num))) {
        return true;
      }

      return false;
    };

    /**
     * @method handleTicketOK 生成工单
     * @return {*}
     */
    const handleTicketOK = () => {
      formRef.value
        .validate()
        .then(() => {
          const {
            title, address, type, describetion, person, duplicateId,handleTimeLimit,
          } =
            formState;
          const params = {
            hotId: props.hotGridId,
            // 地址
            address,
            // 登录人的用户id
            createId: userInfo.value.id,
            // 描述
            describetion,
            // 经纬度
            lat: props.curGrid.lat,
            // 经纬度
            lon: props.curGrid.lon,
            // 工单类型（自动1 / 手动 2)
            orderType: '2',
            // 附件地址
            picPath: fileList.value
              .map((cur: any) => cur.response.data)
              .join(','),
            // 标题
            title,
            // 创建工单类型
            type,
            // 指派处理工单用户id
            userId: person,
            // 抄送人
            duplicateId: duplicateId?.length ? duplicateId.join(',') : '',
            handleTimeLimit: handleTimeLimit ? handleTimeLimit?.format('YYYY-MM-DD HH:mm:ss') : '',
          };

          resetForm();
          store.dispatch('ticket/createOrder', params);
        })
        .catch((error: ValidateErrorEntity<any>) => {
          // console.log('error', error);
        });
    };

    const createOrderResult = computed(
      () => store.state.ticket.createOrderResult
    );

    const changeBlock = () => {
      context.emit('update:isList', !props.isList);
    };

    watch(createOrderResult, (val) => {
      if (val.code) {
        if (val.code === '200') {
          context.emit('updateTicketDetail');
          // message.success('指派成功');
          changeBlock();
        } else {
          // message.success(`指派失败,错误原因：${val.msg}`);
        }

        store.dispatch('ticket/changeOrderResult');
      }
    });

    watch(
      () => props.ticketModalVisible,
      (val) => {
        if (val) {
          store.dispatch('ticket/selectAllCompanyList', {});
        }
      }
    );

    watch(
      () => props.selectOrderCode,
      (val) => {
        getDetail(val);
      }
    );

    watch(
      () => props.action,
      (val) => {
        if (val === 'designate') {
          titles.value = '指派工单';
        }
        if (val === 'audit') {
          titles.value = '审核工单';
        }
        if (val === 'accepted') {
          titles.value = '受理工单';
        }
        if (val === 'reported') {
          titles.value = '核查上报';
        }
      }
    );

    watch(companyList, (val) => {
      formState.unit = val?.[0]?.id;
      store.dispatch('ticket/selectUserListByCompanyId', {
        companyId: val?.[0]?.id,
      });
    });

    watch(userListById, (val) => {
      if (userInfo.value.dataType === 'allData') {
        formState.person = val?.[0]?.id;
        rules.person[0].required = true;
      } else {
        formState.person = '';
        rules.person[0].required = false;
      }

      if (val) {
        duplicateOptions.value = [];
        formState.duplicateId = [];
        val.forEach((item:any) => {
          duplicateOptions.value.push({
            value: item.id,
            label: item.name,
            disabled: item.id === userInfo.value.id.toString(),
          });
        });
      }
    });

    const changeCompany = (val:any) => {
      store.dispatch('ticket/selectUserListByCompanyId', {
        companyId: val,
      });
    };

    const addressList = ref<any[]>([]);

    let timeout: any;
    let currentValue = '';

    const fetch = (value: string, callback: any) => {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      currentValue = value;

      const fake = () => {
        AMap.plugin('AMap.PlaceSearch', () => {
          const autoOptions = {
            city: '全国',
          };
          const placeSearch = new AMap.PlaceSearch(autoOptions);

          placeSearch.search(currentValue, (status: any, result: any) => {
            callback(
              result?.poiList?.pois?.map((cur: any) => ({
                label: cur.name,
                value: `${cur.location.lng},${cur.location.lat}`,
              })) ?? []
            );
          });
        });

        /*
         * axios({
         *   method: 'get',
         *   url: 'https://restapi.amap.com/v5/place/text',
         *   params: {
         *     key: 'da5fd8f8e9fdc7d02163df27f13856a1',
         *     keywords: currentValue,
         *     output: 'json',
         *   },
         *   responseType: 'stream',
         * }).then(({ data, }) => {
         *   callback(
         *     data?.pois?.map((cur: any) => ({
         *       label: cur.name,
         *       value: cur.location,
         *     })) ?? []
         *   );
         * });
         */
      };

      timeout = setTimeout(fake, 300);
    };

    const addressSearch = (val: string) => {
      // eslint-disable-next-line no-return-assign
      fetch(val, (d: any[]) => (addressList.value = d));
    };
    const addressChange = (val: string, option: any) => {
      // eslint-disable-next-line prefer-destructuring
      formState.lon = val.split(',')[0];
      // eslint-disable-next-line prefer-destructuring
      formState.lat = val.split(',')[1];
      formState.address = option.label;

      store.dispatch('ticket/changeLocation', {
        name: option.label,
        location: val.split(','),
      });
      // eslint-disable-next-line no-return-assign
      fetch(val, (d: any[]) => (addressList.value = d));
    };

    watch(() => props.curGrid, (curGrid:any) => {
      if (Object.keys(curGrid).length) {
        const {
          feature, issue, value, address,
        } = curGrid;

        formState.address = address;
        const type = polutionTypes[feature];

        formState.type = allTicketTypeList.findIndex((item: any) => item.label === `热点网格_${type}`) + 1;

        if (address?.indexOf('县') > -1 && address?.indexOf('省') > -1) {
          formState.title = `${address.match(/省(\S*)县/)[1]}县发生${type}热点网格超标`;
        }
        if (address?.indexOf('区') > -1 && address?.indexOf('省') > -1) {
          formState.title = `${address.match(/省(\S*)区/)[1]}区发生${type}热点网格超标`;
        } else {
          formState.title = `${address}发生${type}热点网格超标`;
        }

        const time = moment(issue, 'YYYYMMDDHH').format('YYYY年MM月DD日HH时');

        formState.describetion = `${time}${formState.title}， 超标浓度${value}μg/m³， 请立即前往排查原因。`;
      }
    });

    initHandleTimeLimit();

    return {
      titles,
      serverIp,
      changeBlock,
      grantTicktTypeList,
      addressList,
      acceptTime,
      handleTime,

      formRef,
      labelCol: { span: 6, },
      wrapperCol: { span: 18, },
      itemLabelCol: { span: 3, },
      itemWrapperCol: { span: 21, },
      other: '',
      formState,
      rules,
      zhCN,
      disabledDate,

      resetForm,
      userListById,
      companyList,
      userInfo,
      changeCompany,

      fileList,
      previewVisible,
      previewImage,
      treeData,
      duplicateOptions,
      handlePreview,
      handleChange,
      addressSearch,
      addressChange,
      handleTicketOK,
      handleCloseModal,
    };
  },
});
